import React from 'react';

const Review = ({ review }) => {
    const { description, name, img, location } = review;
    return (
        <section className='my-10 mx-auto shadow-lg rounded-xl p-3 '>
            <div className="my-5">
                <p>{description}</p>
            </div>

            <div className='flex'>
                <div className="avatar p-5">
                    <div className="w-24 rounded-full ring ring-info ring-offset-base-100 ring-offset-2">
                        <img src={img} />

                    </div>
                </div>
                <div className="p-5 mt-5">
                    <h1 className='text-2xl font-semibold'>{name}</h1>
                    <p>{location}</p>
                </div>
            </div>
        </section>
    );
};

export default Review;